<template>
<div class="cb-body__wrap">
	<div class="cb-body__content">
		<div class="cb-section cb-section__title cb-section__title--nospacing cb-section__center">
			{{cmt("upi_loader.sub_header")}}
		</div>

		<div id="timer" class="cb-section cb-section__center">
			<div class="base-timer">
			<svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
				<g class="base-timer__circle">
					<circle class="base-timer__path-elapsed" cx="50" cy="50" r="45" />
					<path :style="color"
						id="base-timer-path-remaining"
						stroke-dasharray="283"
						class="base-timer__path-remaining"
						d="
							M 50, 50
							m -45, 0
							a 45,45 0 1,0 90,0
							a 45,45 0 1,0 -90,0
						"
					></path>
				</g>
			</svg>
			<span id="base-timer-label" class="base-timer__label cb-ff--sans">
				{{formatedTime}}
			</span>
			</div>
		</div>

		<div class="cb-section cb-section__help cb-section__center">
			{{cmt("upi_loader.disclaimer")}}
		</div>
	</div>
</div>
</template>
<style scoped>
#timer {
	margin: 30px 0;
	
}
#timer .base-timer {
  position: relative;
  height: 200px;
  width: 200px;
  margin: 0 auto;
}
#timer .base-timer__circle {
  fill: none;
  stroke: none;
}
#timer .base-timer__path-elapsed {
  stroke-width: 8px;
  stroke: #D4D4E8;
}
#timer .base-timer__label {
  position: absolute;
  width: 200px;
  height: 200px;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
	color: #64648C;
}
#timer .base-timer__path-remaining {
  stroke-width: 8px;
  /* stroke-linecap: round; */
  transform: rotate(90deg);
  transform-origin: center;
  transition: 1s linear all;
  stroke: currentColor;
}
#timer .base-timer__svg {
  transform: scaleX(-1);
}
</style>
<script>
export default {
  data() {
	  return {
			timeLimit: 300,
		  timeLeft: 300,
			interval: null,
	  }
  },
  mounted() {
    this.startTimer();
  },
	destroyed() {
		this.clearIntervals();
	},
  methods: {
    startTimer() {
			this.clearIntervals();
			this.interval = setInterval(() => {
				this.timeLeft = this.timeLeft - 1;
				this.setCircleDasharray();
				if(this.timeLeft == 0) {
					this.clearIntervals();
				}
			}, 1000);
		},
		clearIntervals() {
			if(this.interval){
				clearInterval(this.interval)
			}
		},
		setCircleDasharray() {
			const circleDasharray = `${(
				this.calculateTimeFraction() * 283
			).toFixed(0)} 283`;
			document
				.getElementById("base-timer-path-remaining")
				.setAttribute("stroke-dasharray", circleDasharray);
		},
		calculateTimeFraction() {
			const rawTimeFraction = this.timeLeft / this.timeLimit;
			return rawTimeFraction - (1 / this.timeLimit) * (1 - rawTimeFraction);
		},
  },
	computed: {
		formatedTime() {
			let minutes = Math.floor(this.timeLeft / 60);
			let seconds = this.timeLeft % 60;
			if (seconds < 10) {
				seconds = `0${seconds}`;
			}
			if (minutes < 10) {
				minutes = `0${minutes}`;
			}
			return `${minutes}:${seconds}`;
		},
		color() {
			if(this.timeLeft < 1) {
				return {color: 'red'}
			} else if(this.timeLeft < 15) {
				return {color: 'orange'}
			} else {
				return this.$store.getters.color;
			}
		}
	}
}
</script>

